import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoSpaceOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const spaceOnly: boolean = (control.value || '').trim().length === 0;
    const isValid = !spaceOnly;
    return isValid ? null : { required: 'value is required' };
  };
}
